import React, { Component } from "react";

import {
  CSpinner,
  CBadge,
  CCard,
  CCardBody,
  CCardFooter,
  CCardHeader,
  CButton,
  CCollapse,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CCol,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CSelect,
  CSwitch,
  CTabs,
  CNav,
  CNavItem,
  CNavLink
} from "@coreui/react";
import { Form } from "react-bootstrap";
import ReactDOM from "react-dom";
import {
  RiArrowDownSLine,
  RiArrowUpSLine,
  RiCheckDoubleFill
} from "react-icons/ri";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Col, Label, Row } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import AllocateTutorial from "../../../../assets/imgs/AllocateTutorial.jpeg";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import {
  MINHAS_TRILHAS_PATH,
  TRILHA_BREADCRUMB_LISTAGEM,
  isTrailQueryActive
} from "../../../../config/minhasTrilhas";
import { friendlyDate } from "../../../../utils/date";
import "./style.css";

const appRoot = document.getElementById("root");

class ActivityAllocate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      // allocate: [],
      allocateList: [],
      roomGroups: {},
      selectedGroup: {},
      // user: [],
      // hierarchy: [],
      groups: [],
      regions: [],
      schools: [],
      activity: [],
      activity_id: this.props.match.params.id,
      loading: true,
      allocating: false,
      deleting: false,
      show: null,
      delete_id: null,
      group_id: null,
      region_id: null,
      school_id: null,
      class: "null",
      mine: false,
      homework: false,
      // loadingAlunos: false,
      showInformationModal: true,
      isAllocating: false
    };

    this.error = this.error.bind(this);
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  /* Recorte que os filtros desta tela abrem selecionado.
     Quem manda é o papel do usuário: se ele fixa grupo/regional/escola (e os
     selects aparecem desabilitados), é esse valor que vale. O que sobra pode vir
     por queryParam — é assim que o "Disponibilizar" do relatório da avaliação
     diagnóstica abre esta tela já no recorte escolhido lá. */
  initialFilters() {
    const activeRoles = this.props.general.active_roles;
    const query = new URLSearchParams(this.props.location?.search ?? "");
    const fromQuery = param => parseInt(query.get(param)) || null;

    /* Estudantes que já abrem marcados. Só vem por queryParam, como uma lista
       de ids separados por vírgula — é o que o "Disponibilizar" das atividades
       sugeridas do relatório da atividade manda quando o professor escolheu
       alguns estudantes em vez da turma toda. Ausente é a turma toda. */
    const userIds = (query.get("user_ids") ?? "")
      .split(",")
      .map(id => parseInt(id))
      .filter(id => !Number.isNaN(id));

    return {
      group_id: activeRoles.group_id || fromQuery("group_id"),
      region_id: activeRoles.region_id || fromQuery("region_id"),
      school_id: activeRoles.school_id || fromQuery("school_id"),
      // A turma não vem do papel do usuário: ou está na URL, ou são todas.
      room_id: fromQuery("room_id"),
      user_ids: userIds,
      fromQuery:
        ["group_id", "region_id", "school_id", "room_id"].some(param =>
          fromQuery(param)
        ) || userIds.length > 0
    };
  }

  /* A tela foi aberta pelo relatório da avaliação diagnóstica — o
     "Disponibilizar" de uma atividade sugerida manda `type=diagnostic` junto do
     recorte. Só nesse fluxo Regional e Escola aceitam "Todas"; fora dele os
     filtros continuam exigindo o recorte completo, como sempre. */
  isDiagnosticOrigin() {
    return (
      new URLSearchParams(this.props.location?.search ?? "").get("type") ===
      "diagnostic"
    );
  }

  /* Turmas que já abrem marcadas quando a tela é aberta por um link com
     recorte: só a turma do room_id, se ele vier, ou todas as da lista, que é o
     "Todas as turmas" de quem não escolheu turma nenhuma.

     A lista já vem recortada por grupo/regional/escola pelo próprio fetchData;
     aqui sobra filtrar as turmas de classe e descartar as que já têm alocação,
     que nem têm caixa de seleção. */
  roomsToPreselect(list) {
    const { room_id: roomId } = this.initialFilters();

    return list
      .filter(
        room =>
          room.class &&
          room.allocation_id === 0 &&
          (!roomId || room.room_id === roomId)
      )
      .map(room => room.room_id);
  }

  /* Marca, nas turmas pré-selecionadas, só os estudantes que vieram no link.

     A busca dos estudantes é a mesma do card expandido — eles não vêm com a
     lista de turmas, então sem carregá-los aqui não há em quem marcar. E a turma
     abre expandida: a seleção veio de outra tela, e escondê-la faria a alocação
     parecer da turma inteira.

     Sem `user_ids` no link nada disso acontece: a turma continua marcada por
     inteiro, que é o comportamento de sempre. */
  preselectUsers(list) {
    const { room_id: roomId, user_ids: userIds } = this.initialFilters();

    if (!userIds.length) return;

    const rooms = list.filter(
      room =>
        room.class &&
        room.allocation_id === 0 &&
        (!roomId || room.room_id === roomId)
    );

    if (rooms.length === 1) {
      this.setState({ show: rooms[0].room_id });
    }

    rooms.forEach(room => {
      this.carregarAlunos(room).then(() => {
        this.setState(state => {
          const lista = [...state.list];
          const index = lista.findIndex(item => item.room_id === room.room_id);

          if (index < 0) return null;

          /* A busca dos estudantes falhou (ou a turma está vazia): deixa a
             turma marcada por inteiro, que é o mais próximo do que o link
             pediu, em vez de desmarcá-la por não ter em quem marcar. */
          if (!lista[index].users.length) return null;

          lista[index].users.forEach(user => {
            user.checked = userIds.includes(user.id);
          });

          /* A turma só entra na alocação se sobrou alguém marcado — uma turma
             no allocateList sem estudante marcado é "a turma toda", e não é o
             que o link pediu. O filtro também limpa as duplicatas que a
             pré-seleção de turmas pode ter deixado. */
          const allocateList = state.allocateList.filter(
            id => id !== room.room_id
          );

          if (lista[index].users.some(user => user.checked)) {
            allocateList.push(room.room_id);
          }

          return { list: lista, allocateList };
        });
      });
    });
  }

  /* A pré-seleção vale só para a primeira busca, a que nasce do link. Depois
     dela quem manda é o usuário, e trocar um filtro não remarca nada. */
  consumeRoomPreselect() {
    if (!this.roomPreselectPending) return false;

    this.roomPreselectPending = false;

    return true;
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    const filters = this.initialFilters();

    this.roomPreselectPending = filters.fromQuery;

    if (
      this.props.user.user_roles[0].role_id === 1 ||
      this.props.user.user_roles[0].role_id === 2 ||
      this.props.user.user_roles[0].role_id === 3 ||
      this.props.user.user_roles[0].role_id === 4
    ) {
      this.getRegions(filters.group_id);
      if (filters.region_id) {
        this.getSchools(filters.group_id, filters.region_id);
      }
      (async () => {
        await axios
          .all([
            axios.get(
              `${URL.api}activity/activity/singleView/${this.state.activity_id}`,
              { headers: { Authorization: `Bearer ${this.props.user.token}` } }
            ),
            axios.get(`${URL.api}access/group/list`, {
              headers: { Authorization: `Bearer ${this.props.user.token}` }
            }),
            axios.get(`${URL.api}classification/serie/list`, {
              headers: { Authorization: `Bearer ${this.props.user.token}` }
            })
          ])
          .then(
            axios.spread(
              (respActivity, respGroups, respSeries) => {
                this.setState({
                  series: respSeries.data.data,
                  groups: respGroups.data.data,
                  activity: respActivity.data.data,
                  group_id: filters.group_id ? filters.group_id : 0,
                  region_id: filters.region_id ? filters.region_id : 0,
                  school_id: filters.school_id ? filters.school_id : 0,
                  loading: false
                });
              },
              error => {
                this.error("Não foi possível obter as informações da alocação");
              }
            )
          );
      })();
    }
    if (
      this.props.general.active_roles.group_id &&
      this.props.general.active_roles.region_id &&
      this.props.general.active_roles.school_id
    ) {
      (async () => {
        await this.fetchData();
      })();
    } else if (
      filters.fromQuery &&
      filters.group_id &&
      /* Vindo do relatório diagnóstico basta o grupo: regional e escola vazias
         significam "todas", e a busca traz as turmas de todas elas. Fora desse
         fluxo, o recorte precisa estar completo para buscar, como antes. */
      (this.isDiagnosticOrigin() || (filters.region_id && filters.school_id))
    ) {
      /* Grava no state antes de buscar, porque o fetchData lê
         group_id/region_id/school_id de lá. */
      this.setState(
        {
          group_id: filters.group_id,
          region_id: filters.region_id || 0,
          school_id: filters.school_id || 0
        },
        () => {
          this.fetchData();
        }
      );
    } else {
      this.setState({ loading: false });
    }
  }

  getRegions = groupId => {
    try {
      axios
        .get(`${URL.api}access/region/listRegionFilter/${groupId}`, {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        })
        .then(resp => {
          this.setState({ regions: resp.data.data });
        });
    } catch {
      this.setState({
        region_id: 0
      });
    }
  };

  getSchools = (groupId, regionId) => {
    try {
      axios
        .get(
          `${URL.api}access/school/listSchoolFilter/${groupId}/${regionId}`,
          {
            headers: { Authorization: `Bearer ${this.props.user.token}` }
          }
        )
        .then(resp => {
          this.setState({ schools: resp.data.data });
        });
    } catch {
      this.setState({
        school_id: 0
      });
    }
  };

  async fetchData(communityOnly = false) {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    this.setState({ loading: true });

    let objAllocate = {
      activity_id: this.state.activity_id,
      room_id: 0,
      user_id: 0
    };

    let currYear = new Date().getFullYear();

    await axios
      .all([
        axios.get(`${URL.api}community/room/listAllocationByFilter`, {
          params: {
            group_id: this.state.group_id,
            region_id: this.state.region_id,
            school_id:
              this.state.school_id ?? this.props.general.active_roles.school_id,
            series: this.state.serie_id
              ? JSON.stringify([this.state.serie_id])
              : null,
            user_id: this.props.user.user.id,
            role_id: this.props.general.active_roles.role_id,
            class: !communityOnly,
            start: `${currYear}-01-01`,
            end: `${currYear}-12-31`
          },
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.post(`${URL.api}activity/allocate/list`, objAllocate, {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        }),
        axios.get(
          `${URL.api}activity/activity/singleView/${this.state.activity_id}`,
          { headers: { Authorization: `Bearer ${this.props.user.token}` } }
        ),
        axios.get(`${URL.api}classification/serie/list`, {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        })
      ])
      .then(
        axios.spread(
          (resp, respAllocate, respActivity, respSeries) => {
            let list = [];
            let allocation = respAllocate.data.data;
            for (let i = 0; i < resp.data.data.length; i++) {
              let obj = {
                allocation_id: 0,
                room_id: resp.data.data[i].id,
                room_name: resp.data.data[i].name,
                room_id_external: resp.data.data[i].external_id,
                room_school_id: resp.data.data[i].school_id,
                room_school_name: resp.data.data[i].school_name,
                room_region_id: resp.data.data[i].region_id,
                room_region_name: resp.data.data[i].region_name,
                room_group_id: resp.data.data[i].group_id,
                room_group_name: resp.data.data[i].group_name,
                release: false,
                homework: false,
                start_allocation: "",
                end_allocation: "",
                originalStart: "",
                originalEnd: "",
                originalHomework: false,
                allocatedUserIds: [],
                users: [],
                show: false,
                class: resp.data.data[i].class,
                students_count: resp.data.data[i]?.students_count
              };

              for (let j = 0; j < allocation.length; j++) {
                if (allocation[j].room_id === obj.room_id) {
                  obj.allocation_id = allocation[j].id;
                  obj.release = allocation[j].release;
                  obj.homework = allocation[j].homework;
                  obj.start_allocation = `${
                    allocation[j].start.split(" ")[0]
                  }T${allocation[j].start.split(" ")[1]}`;
                  obj.end_allocation = `${allocation[j].end.split(" ")[0]}T${
                    allocation[j].end.split(" ")[1]
                  }`;
                  obj.originalStart = obj.start_allocation;
                  obj.originalEnd = obj.end_allocation;
                  obj.originalHomework = obj.homework;
                  obj.allocatedUserIds = allocation[j].users.map(
                    user => user.user_id
                  );
                }
              }

              list.push(obj);
            }

            const preselect = this.consumeRoomPreselect();

            this.setState(
              {
                list,
                // allocation,
                series: respSeries.data.data,
                activity: respActivity.data.data,
                loading: false,
                ...(preselect
                  ? { allocateList: this.roomsToPreselect(list) }
                  : {})
              },
              () => {
                if (preselect) this.preselectUsers(list);
              }
            );
          },
          error => {
            this.error("Não foi possível obter as informações da alocação");
          }
        )
      );
  }

  onChangeAction = event => {
    let field = event.target.name.split("_")[0];
    let roomId = parseInt(event.target.name.split("_")[1]);
    let list = [];
    this.state.list.forEach(item => {
      list.push(item);
    });

    for (let i = 0; i < list.length; i++) {
      if (roomId === list[i].room_id) {
        if (field === "start") {
          list[i].start_allocation = event.target.value;
        } else if (field === "end") {
          list[i].end_allocation = event.target.value;
        } else if (field === "homework") {
          list[i].homework = event.target.checked;
        }
      }
    }

    this.setState({
      list
    });
  };

  onChangeCheckBox = event => {
    let roomId = parseInt(event.target.id.split("_")[0]);
    this.limparSelecaoDeGrupo(roomId);
    let userId = parseInt(event.target.id.split("_")[1]);
    let list = [];
    this.state.list.forEach(item => {
      list.push(item);
    });

    let userChecked = [];

    for (let i = 0; i < list.length; i++) {
      if (roomId === list[i].room_id) {
        for (let j = 0; j < list[i].users.length; j++) {
          if (userId === list[i].users[j].id) {
            list[i].users[j].checked = !list[i].users[j].checked;
          }
          if (list[i].users[j].checked) {
            userChecked.push(list[i].users[j].id);
          }
        }
      }
    }

    let allocateList = [];
    for (let i = 0; i < this.state.allocateList.length; i++) {
      allocateList.push(this.state.allocateList[i]);
    }
    if (userChecked.length) {
      allocateList.push(roomId);
    } else {
      allocateList.splice(allocateList.indexOf(roomId), 1);
    }

    this.setState({
      list,
      allocateList
    });
  };

  /* A turma está selecionada por inteiro: ou ela entrou no allocateList sem
     nenhum estudante marcado individualmente, ou todos os estudantes dela estão
     marcados. É o que pinta o card e o que troca o rótulo para "Selecionado". */
  isRoomFullySelected(classes) {
    const checkedUsers = classes.users.filter(
      user => user.checked === true
    ).length;

    return (
      (checkedUsers === 0 &&
        this.state.allocateList.filter(id => id === classes.room_id).length ===
          1) ||
      (checkedUsers === classes.students_count && classes.students_count !== 0)
    );
  }

  onChangeCheckBoxAll = event => {
    let roomId = parseInt(event.target.id.split("_")[0]);
    this.limparSelecaoDeGrupo(roomId);
    let list = [];
    this.state.list.forEach(item => {
      list.push(item);
    });

    for (let i = 0; i < list.length; i++) {
      if (roomId === list[i].room_id) {
        for (let j = 0; j < list[i].users.length; j++) {
          list[i].users[j].checked = false;
        }
      }
    }

    let allocateList = [];
    for (let i = 0; i < this.state.allocateList.length; i++) {
      allocateList.push(this.state.allocateList[i]);
    }

    if (this.state.allocateList.filter(id => id === roomId).length) {
      allocateList.splice(allocateList.indexOf(roomId), 1);
    } else {
      allocateList.push(roomId);
    }
    this.setState({
      list,
      allocateList
    });
  };

  allocateAction = (roomIDs, startAllocation, endAllocation, homework) => {
    if (roomIDs.length !== 1) {
      this.setState({ allocating: "main" });
    } else {
      this.setState({ allocating: roomIDs[0] });
    }

    if (startAllocation === undefined || endAllocation === undefined) {
      toastr.error("Erro", `Preencha as datas de início e fim da alocação!`);
      this.setState({ allocating: false });
      return;
    }

    if (!roomIDs?.length) {
      toastr.error("Erro", `Escolha ao menos uma turma para alocar!`);
      this.setState({ allocating: false });
      return;
    }

    const roomList = [];
    this.state.list.map(room => {
      if (roomIDs.includes(room.room_id)) {
        roomList.push(room);
      }
    });

    const shouldNotice = !roomList[0].allocation_id;

    let obj = {
      activity_id: this.state.activity_id,
      room_list: roomList
    };

    for (let i = 0; i < obj.room_list.length; i++) {
      obj.room_list[i].start_allocation = startAllocation.replace("T", " ");
      obj.room_list[i].end_allocation = endAllocation.replace("T", " ");
      obj.room_list[i].homework = homework;
    }

    for (let i = 0; i < obj.room_list.length; i++) {
      let users = [];
      for (let j = 0; j < obj.room_list[i].users.length; j++) {
        if (obj.room_list[i].users[j].checked) {
          users.push(obj.room_list[i].users[j]);
        }
      }
      obj.room_list[i].users = users;
    }

    this.setState({ isAllocating: true });
    axios
      .post(`${URL.api}activity/allocate/insert`, obj, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.setState(state => ({
          list: state.list.map(room => {
            let allocationID;
            resp.data.data?.map(allocation => {
              if (allocation.room_id === room.room_id) {
                allocationID = allocation.id;
              }
            });
            return roomIDs.includes(room.room_id)
              ? {
                  ...room,
                  allocation_id: allocationID,
                  start_allocation: startAllocation,
                  end_allocation: endAllocation,
                  homework,
                  originalStart: startAllocation,
                  originalEnd: endAllocation,
                  originalHomework: homework,
                  allocatedUserIds: room.users.map(user => user.id)
                }
              : room;
          }),
          allocating: false
        }));

        toastr.success(
          "Alocada com sucesso!",
          "A avaliação foi alocada na turma"
        );

        if (shouldNotice) {
          let notices = [];
          for (let i = 0; i < resp.data.data.length; i++) {
            let objNotice = {
              user_id: this.props.user.user.id,
              title: "Nova avaliação alocada",
              description: `A avaliação ${
                this.state.activity?.name
              } foi alocada com início definido para ${friendlyDate(
                resp.data.data[i].start
              )} e fim definido para ${friendlyDate(resp.data.data[i].end)}.`,
              type: "notification",
              activities: [resp.data.data[i].id],
              roles: [
                {
                  room_id: resp.data.data[i].room_id,
                  role_id: 7,
                  group_id: this.props.general.active_roles.group_id,
                  region_id: this.props.general.active_roles.region_id,
                  school_id: this.props.general.active_roles.school_id
                }
              ]
            };
            if (resp.data.data[i].id) {
              notices.push(objNotice);
            }
          }

          if (notices.length > 0) {
            axios
              .post(`${URL.api}communication/notice/insert`, notices[0], {
                headers: { authorization: `Bearer ${this.props.user.token}` }
              })
              .then(
                resp => {
                  this.setState({ allocating: false });
                },
                error => {
                  this.error("Não foi possível inserir o aviso dessa alocação");
                  this.setState({ allocating: false });
                }
              );
          } else {
            this.setState({ allocating: false });
          }
        }
      })
      .finally(() => {
        this.setState({ isAllocating: false });
      });
  };

  deleteAction = allocationId => {
    this.setState({ deleting: true });

    axios
      .post(
        `${URL.api}activity/allocate/delete`,
        { id: allocationId },
        {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        }
      )
      .then(
        resp => {
          this.setState(state => ({
            list: state.list.map(room =>
              room.allocation_id === allocationId
                ? { ...room, allocation_id: 0 }
                : room
            ),
            deleting: false,
            showDeleteModal: false
          }));

          toastr.success("Apagada com sucesso!", "A alocação foi apagada");
        },
        error => {
          this.setState(state => ({
            deleting: false,
            showDeleteModal: false
          }));

          toastr.error("Falha", "Não foi possível apagar a alocação");
        }
      );
  };

  copyText(link) {
    let tempInput = document.createElement("input");
    tempInput.style = "position: absolute; left: -1000px; top: -1000px";
    tempInput.value = link;
    document.body.appendChild(tempInput);
    tempInput.select();
    tempInput.setSelectionRange(0, 99999);
    document.execCommand("copy");
    document.body.removeChild(tempInput);

    toastr.success(
      "Sucesso",
      "O link foi copiado para sua área de transferência"
    );
  }

  alunosRender(classes) {
    this.setState(state => ({
      show: state.show === classes.room_id ? null : classes.room_id
    }));

    this.carregarAlunos(classes);
  }

  /* ------------------------------------------------------------------
     SELETOR DE GRUPOS

     Os grupos de todas as turmas da página vêm numa request só
     (community/room_group/listByRooms), com os ids dos alunos de cada grupo
     embutidos -- escolher um grupo precisa marcar os alunos na hora, e ir ao
     servidor a cada escolha deixaria o clique lento sem motivo.

     A sincronização mora no componentDidUpdate, e não no callback de quem
     carrega as turmas, porque a lista é remontada por vários caminhos
     (filtros de grupo, região, escola, série). A assinatura dos room_ids
     evita o laço de request infinito.
     ------------------------------------------------------------------ */
  sincronizarGrupos() {
    const rooms = (this.state.list || []).map(item => item.room_id);
    const assinatura = rooms.join(",");

    if (assinatura === this.assinaturaGrupos) return;

    // Instância e não state: isto controla o efeito, não a renderização.
    this.assinaturaGrupos = assinatura;

    if (!rooms.length) return;

    axios
      .post(
        `${URL.api}community/room_group/listByRooms`,
        { rooms },
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(resp => {
        if (resp.data.success) {
          this.setState({ roomGroups: resp.data.data || {} });
        }
      })
      // Sem toastr: o seletor é um atalho. Se ele falhar, a tela de alocação
      // continua inteira e um toast de erro só assustaria.
      .catch(() => {});
  }

  /* Carrega os alunos da turma. Extraído do alunosRender porque o seletor de
     grupo também precisa deles: o card nasce fechado e os alunos só eram
     buscados ao expandir -- sem isso não há em quem marcar a seleção. */
  carregarAlunos(classes) {
    const lista = [...this.state.list];
    const index = this.findIndexx({ room_id: classes.room_id });

    return axios
      .post(
        `${URL.api}community/room_user/list`,
        { room: classes.room_id, role_id: 7 },
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(resp => {
        if (resp.data.data.length && !lista[index]?.cAlunos) {
          lista[index].cAlunos = true;
          for (let j = 0; j < resp.data.data.length; j++) {
            if (!resp.data.data[j].administrator) {
              lista[index].users.push({
                id: resp.data.data[j].user_id,
                name: resp.data.data[j].user_name,
                photo: resp.data.data[j].user_photo,
                checked: (lista[index].allocatedUserIds || []).includes(
                  resp.data.data[j].user_id
                )
              });
            }
          }
        }

        // eslint-disable-next-line react/no-unused-state
        this.setState({ loadingAlunos: false, list: lista });
      })
      .catch(() => {
        toastr.error("Falha", "Não carregar os estudantes");
      });
  }

  /* Marca exatamente os alunos do grupo escolhido, desmarcando o resto da
     turma. Grupo vazio (opção "Nenhum") desmarca todos -- a seleção veio do
     seletor, então limpá-lo desfaz o que ele fez. */
  aplicarGrupo(classes, groupId) {
    // Forma de callback: list, allocateList e roomGroups são todos derivados
    // do estado anterior, e aplicarGrupo é chamado de dentro de um .then().
    this.setState(state => {
      const grupos = state.roomGroups[classes.room_id] || [];
      const grupo = grupos.find(item => String(item.id) === String(groupId));
      const ids = grupo ? grupo.users : [];

      const list = [...state.list];
      const index = list.findIndex(item => item.room_id === classes.room_id);

      if (index < 0) return null;

      list[index].users.forEach(user => {
        user.checked = ids.includes(user.id);
      });

      /* allocateList marca "a turma entra na alocação". Um grupo é
         subconjunto, então a turma entra se sobrou alguém marcado e sai se
         não sobrou. O filtro também limpa as duplicatas que o
         onChangeCheckBox acumula. */
      const algumMarcado = list[index].users.some(user => user.checked);
      const allocateList = state.allocateList.filter(
        id => id !== classes.room_id
      );

      if (algumMarcado) {
        allocateList.push(classes.room_id);
      }

      return { list, allocateList };
    });
  }

  selecionarGrupo(classes, groupId) {
    this.setState(state => ({
      selectedGroup: { ...state.selectedGroup, [classes.room_id]: groupId }
    }));

    if (classes.cAlunos) {
      this.aplicarGrupo(classes, groupId);
      return;
    }

    // Alunos ainda não carregados (card fechado): busca antes de marcar.
    this.carregarAlunos(classes).then(() =>
      this.aplicarGrupo(classes, groupId)
    );
  }

  /* O seletor deixa de refletir a realidade no instante em que o usuário mexe
     num aluno na mão. Em vez de mostrar "Grupo A" com outra seleção na tela,
     ele volta para "Nenhum". */
  limparSelecaoDeGrupo(roomId) {
    if (!this.state.selectedGroup[roomId]) return;

    this.setState(state => ({
      selectedGroup: { ...state.selectedGroup, [roomId]: "" }
    }));
  }

  componentDidUpdate() {
    this.sincronizarGrupos();
  }

  findIndexx(obj) {
    return this.state.list.findIndex(
      current => current.room_id === obj.room_id
    );
  }

  isRoomEdited = classes => {
    if (classes.start_allocation !== classes.originalStart) return true;
    if (classes.end_allocation !== classes.originalEnd) return true;
    if (classes.homework !== classes.originalHomework) return true;

    if (classes.cAlunos) {
      const currentIds = classes.users
        .filter(user => user.checked)
        .map(user => user.id)
        .sort((a, b) => a - b);
      const originalIds = [...(classes.allocatedUserIds || [])].sort(
        (a, b) => a - b
      );

      if (currentIds.length !== originalIds.length) return true;
      for (let i = 0; i < currentIds.length; i++) {
        if (currentIds[i] !== originalIds[i]) return true;
      }
    }

    return false;
  };

  render() {
    // const list = this.state.list;
    // SOLUÇÃO PARCIAL - Necessário Corrigir
    // Professor não estava conseguindo alocar uma atividade nas turmas que ele pois
    // o this.state.group_id, region_id e school_id permanece o mesmo mesmo trocando de perfil
    //
    const list = this.state.list?.filter(
      item =>
        (!this.state.group_id || item.room_group_id === this.state.group_id) &&
        (!this.state.region_id ||
          item.room_region_id === this.state.region_id) &&
        (!this.state.school_id ||
          item.room_school_id === this.state.school_id) &&
        (this.state.class === "null" ||
          item.class === (this.state.class === "true")) &&
        (!this.state.mine || !!item.mine)
    );

    const classrooms = list?.filter(item => item.class);
    const rooms = list?.filter(item => !item.class);

    const listRooms = this.state.content ? rooms : classrooms;

    /* Rótulo da opção vazia de Regional e Escola. No fluxo do relatório
       diagnóstico ela é um recorte válido ("todas"); fora dele continua sendo o
       "Selecionar" de sempre, que não busca nada por si. */
    const optionalFilters = this.isDiagnosticOrigin();
    const emptyOptionLabel = optionalFilters ? "Todas" : "Selecionar";

    return (
      <React.Fragment>
        <CModal show={this.state.showInformationModal} centered size="lg">
          <CModalHeader closeButton={false}>
            <CModalTitle>Aviso!</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <img
              src={AllocateTutorial}
              alt="Como alocar sua atividade"
              className="w-100 mb-3"
            />
            <h4>
              <strong>
                Siga os passos a seguir para alocar sua atividade:
              </strong>
            </h4>
            <ol>
              <li>
                <h5>Selecione a data de início da atividade.</h5>
              </li>
              <li>
                <h5>Selecione a data de fim da atividade.</h5>
              </li>
              <li>
                <h5>
                  Selecione as turmas para qual deseja alocar a atividade.
                </h5>
              </li>
              <li>
                <h5>Clique em Alocar.</h5>
              </li>
            </ol>
          </CModalBody>
          <CModalFooter>
            <CButton
              color="secondary"
              onClick={() => this.setState({ showInformationModal: false })}
            >
              Fechar
            </CButton>
          </CModalFooter>
        </CModal>
        <Breadcrumb
          current={this.props.currentRoute}
          items={[
            isTrailQueryActive(this.props.location?.search)
              ? {
                  path: "/activity/list",
                  to: MINHAS_TRILHAS_PATH,
                  name: TRILHA_BREADCRUMB_LISTAGEM
                }
              : { path: "/activity/list", to: "/activity/list" }
          ]}
        />
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <Row>
            {["G", "U", "R", "E"].includes(
              this.props.general.active_roles.type
            ) && (
              <CCard className="w-100">
                <CCardBody>
                  <CCol className="d-flex flex-wrap allocate-filters-row">
                    <div className="w-100 mr-2 allocate-filter-item">
                      <div className="w-100 text-ellipsis">
                        <Label className="d-block w-100 text-ellipsis">
                          Grupo
                        </Label>
                      </div>
                      <CInputGroup className="mb-2">
                        <CInputGroupPrepend>
                          <CInputGroupText>
                            <i className="fa fa-wrench"></i>
                          </CInputGroupText>
                        </CInputGroupPrepend>
                        <CSelect
                          value={this.state.group_id}
                          placeholder="Grupo"
                          onChange={e => {
                            this.setState(
                              {
                                group_id: parseInt(e.target.value),
                                list: null,
                                region_id: 0,
                                school_id: 0,
                                serie_id: 0
                              },
                              () => {
                                this.fetchData(true);
                              }
                            );
                            this.getRegions(e.target.value);
                          }}
                          disabled={!!this.props.general.active_roles.group_id}
                        >
                          <option value="0">Todos</option>
                          {this.state?.groups.map(item => (
                            <option value={item.id}>{item.name}</option>
                          ))}
                        </CSelect>
                      </CInputGroup>
                    </div>
                    <div className="w-100 mr-2 allocate-filter-item">
                      <div className="w-100 text-ellipsis">
                        <Label className="d-block w-100 text-ellipsis">
                          Regional
                        </Label>
                      </div>
                      <CInputGroup className="mb-2">
                        <CInputGroupPrepend>
                          <CInputGroupText>
                            <i className="fa fa-globe"></i>
                          </CInputGroupText>
                        </CInputGroupPrepend>
                        <CSelect
                          value={this.state.region_id}
                          placeholder="Regional"
                          disabled={
                            !this.state.group_id ||
                            !!this.props.general.active_roles.region_id
                          }
                          onChange={e => {
                            this.setState(
                              {
                                region_id: parseInt(e.target.value),
                                list: null,
                                school_id: 0,
                                serie_id: 0
                              },
                              () => {
                                this.fetchData(true);
                              }
                            );
                            this.getSchools(
                              this.state.group_id,
                              e.target.value
                            );
                          }}
                        >
                          <option value="0">{emptyOptionLabel}</option>
                          {this.state.regions?.map(item => (
                            <option value={item.id}>{item.name}</option>
                          ))}
                        </CSelect>
                      </CInputGroup>
                    </div>
                    <div className="w-100 mr-2 allocate-filter-item">
                      <div className="w-100 text-ellipsis">
                        <Label className="d-block w-100 text-ellipsis">
                          Escola
                        </Label>
                      </div>
                      <CInputGroup className="mb-2">
                        <CInputGroupPrepend>
                          <CInputGroupText>
                            <i className="fa fa-institution"></i>
                          </CInputGroupText>
                        </CInputGroupPrepend>
                        <CSelect
                          value={this.state.school_id}
                          placeholder="Escola"
                          onChange={e => {
                            const schoolId = parseInt(e.target.value);

                            /* Escola vazia: no fluxo do relatório diagnóstico
                               significa "todas as escolas" e rebusca sem o
                               filtro; fora dele mantém o comportamento antigo,
                               de limpar a lista. */
                            if (schoolId !== 0 || optionalFilters) {
                              this.setState(
                                { school_id: schoolId, serie_id: 0 },
                                () => {
                                  this.fetchData();
                                }
                              );
                            } else {
                              this.setState({
                                school_id: schoolId,
                                serie_id: 0,
                                list: []
                              });
                            }
                          }}
                          disabled={
                            /* Com "Todas" na regional não há escolas carregadas
                               para escolher, então basta o grupo para o campo
                               ficar utilizável. */
                            (optionalFilters
                              ? !this.state.group_id
                              : !this.state.region_id) ||
                            !!this.props.general.active_roles.school_id
                          }
                        >
                          <option value="0">{emptyOptionLabel}</option>
                          {this.state.schools?.map(item => (
                            <option value={item.id}>{item.name}</option>
                          ))}
                        </CSelect>
                      </CInputGroup>
                    </div>
                    <div className="w-100 mr-2 allocate-filter-item">
                      <div className="w-100 text-ellipsis">
                        <Label className="d-block w-100 text-ellipsis">
                          Séries
                        </Label>
                      </div>
                      <CInputGroup className="mb-2">
                        <CInputGroupPrepend>
                          <CInputGroupText>
                            <i className="fa fa-institution"></i>
                          </CInputGroupText>
                        </CInputGroupPrepend>
                        <CSelect
                          value={this.state.serie_id}
                          placeholder="Série"
                          onChange={e => {
                            this.setState(
                              {
                                serie_id: parseInt(e.target.value)
                              },
                              () => {
                                this.fetchData(parseInt(e.target.value));
                              }
                            );
                          }}
                          disabled={!this.state.school_id}
                        >
                          <option value="0">Selecionar</option>
                          {this.state.series?.map(item => (
                            <option value={item.id}>{item.name}</option>
                          ))}
                        </CSelect>
                      </CInputGroup>
                    </div>
                    {/* <div className="w-100 text-ellipsis">
                        <Label className="d-block w-100 text-ellipsis">
                          Tipo de sala
                        </Label>
                      </div>
                      <CInputGroup>
                        <CInputGroupPrepend>
                          <CInputGroupText>
                            <i className="fa fa-users"></i>
                          </CInputGroupText>
                        </CInputGroupPrepend>
                        <CSelect
                          value={this.state.class}
                          placeholder="Tipo de sala"
                          onChange={e =>
                            this.setState({ class: e.target.value })
                          }
                        >
                          <option value="null">Todas</option>
                          <option value="true">Turmas</option>
                          <option value="false">Comunidades</option>
                        </CSelect>
                      </CInputGroup> */}
                  </CCol>
                  {/* <CCol className="d-flex flex-column">
                        <div className="w-100 text-ellipsis">
                          <Label className="d-block w-100 text-ellipsis">
                            Apenas minhas
                          </Label>
                        </div>
                        <div className="flex-1 d-flex align-items-center">
                          <CSwitch
                            shape="pill"
                            color="primary"
                            checked={this.state.mine}
                            onChange={e =>
                              this.setState({ mine: e.target.checked })
                            }
                          />
                        </div>
                      </CCol> */}
                </CCardBody>
              </CCard>
            )}
            <Col md="12">
              <h3 className="mb-4">
                Aloque <strong>{this.state.activity?.name}</strong>
              </h3>
              <CTabs>
                <CNav variant="tabs" className="d-flex flex-wrap mb-4">
                  <CNavItem onClick={() => this.setState({ content: 0 })}>
                    <CNavLink className="tab-not-focus">
                      <h4
                        className="d-inline-block mr-1 mb-0 p-1"
                        style={
                          this.state.content === 1 ? { color: "#000000" } : {}
                        }
                      >
                        Turma
                      </h4>
                    </CNavLink>
                  </CNavItem>
                  <CNavItem onClick={() => this.setState({ content: 1 })}>
                    <CNavLink className="tab-not-focus">
                      <h4
                        className="d-inline-block mr-1 mb-0 p-1"
                        style={
                          this.state.content === 0 ? { color: "#000000" } : {}
                        }
                      >
                        Comunidade
                      </h4>
                    </CNavLink>
                  </CNavItem>
                  <div className="flex-1 d-flex flex-wrap justify-content-end align-items-center allocate-datetime-row">
                    <div className="d-flex align-items-center allocate-datetime-group">
                      <span className="mr-2">Início:</span>
                      <Form.Control
                        type="datetime-local"
                        name="start"
                        value={this.state.start_allocation}
                        step="1"
                        onChange={e =>
                          this.setState({ start_allocation: e.target.value })
                        }
                        className="allocate-datetime-input"
                        style={{ width: "16rem" }}
                      />
                    </div>
                    <div className="d-flex align-items-center allocate-datetime-group">
                      <span className="ml-3 mr-2">Fim:</span>
                      <Form.Control
                        type="datetime-local"
                        name="end"
                        value={this.state.end_allocation}
                        step="2"
                        onChange={e =>
                          this.setState({ end_allocation: e.target.value })
                        }
                        className="allocate-datetime-input"
                        style={{ width: "16rem" }}
                      />
                    </div>
                    <div className="d-flex align-items-center allocate-datetime-group">
                      <span className="ml-3 mr-2">Para casa:</span>
                      <CSwitch
                        shape="pill"
                        color="primary"
                        checked={this.state.homework}
                        onChange={e =>
                          this.setState({ homework: e.target.checked })
                        }
                        disabled={
                          !(
                            this.state.list?.length &&
                            this.state.allocateList?.length &&
                            this.state.start_allocation &&
                            this.state.end_allocation
                          )
                        }
                      />
                    </div>
                    {!this.state.isAllocating ? (
                      <CButton
                        color="primary"
                        className="d-flex ml-2 justify-content-center align-items-center"
                        onClick={() =>
                          this.allocateAction(
                            this.state.allocateList,
                            this.state.start_allocation,
                            this.state.end_allocation,
                            this.state.homework
                          )
                        }
                        disabled={
                          !(
                            this.state.list?.length &&
                            this.state.allocateList?.length &&
                            this.state.start_allocation &&
                            this.state.end_allocation
                          )
                        }
                      >
                        <>
                          <span
                            style={
                              this.state.allocating === "main"
                                ? { opacity: 0 }
                                : null
                            }
                          >
                            Alocar
                          </span>
                          {this.state.allocating === "main" && (
                            <CSpinner
                              size="sm"
                              color="white"
                              style={{ position: "absolute" }}
                            />
                          )}
                        </>
                      </CButton>
                    ) : (
                      <div style={{ marginLeft: "10px" }}>
                        <CSpinner size="sm" color="#114f72" />
                      </div>
                    )}
                  </div>
                </CNav>
              </CTabs>

              {listRooms?.length > 0 ? (
                <>
                  {listRooms?.map(classes => (
                    <CCard
                      accentColor={this.state.content ? "danger" : "primary"}
                      key={classes.room_id}
                    >
                      <CCardHeader
                        className={
                          this.state.show === classes.room_id
                            ? "d-flex align-items-center flex-wrap allocate-room-header"
                            : "d-flex align-items-center flex-wrap rounded border-0 allocate-room-header"
                        }
                      >
                        <h4 className="m-0 p-0 flex-1 d-flex align-items-center allocate-room-title">
                          {classes.room_name}
                          {classes.room_id_external && (
                            <span className="text-muted ml-2 small">
                              {" "}
                              ({classes.room_id_external})
                            </span>
                          )}
                          {classes.allocation_id !== 0 && (
                            <RiCheckDoubleFill className="ml-2 text-success" />
                          )}
                          {classes.allocation_id !== 0 && (
                            <CBadge color="info" className="ml-2">
                              {classes.homework ? "Casa" : "Classe"}
                            </CBadge>
                          )}
                        </h4>
                        {classes.allocation_id === 0 && (
                          <CCard
                            className={`user-card-allocate m-0 mr-2${
                              this.isRoomFullySelected(classes)
                                ? " checked-primary"
                                : ""
                            }`}
                            onClick={() =>
                              this.onChangeCheckBoxAll({
                                target: { id: `${classes.room_id}_0` }
                              })
                            }
                          >
                            <div className="px-3 py-2 d-flex align-items-center h-100">
                              {this.isRoomFullySelected(classes)
                                ? "Selecionado"
                                : "Selecionar"}
                            </div>
                          </CCard>
                        )}
                        {(this.state.roomGroups[classes.room_id] || []).length >
                          0 && (
                          <CSelect
                            className="mr-2 allocate-group-select"
                            style={{ width: "170px" }}
                            value={
                              this.state.selectedGroup[classes.room_id] || ""
                            }
                            title="Selecionar os alunos de um grupo"
                            onClick={e => e.stopPropagation()}
                            onChange={e =>
                              this.selecionarGrupo(classes, e.target.value)
                            }
                          >
                            <option value="">Nenhum grupo</option>
                            {this.state.roomGroups[classes.room_id].map(
                              grupo => (
                                <option key={grupo.id} value={grupo.id}>
                                  {grupo.name}
                                </option>
                              )
                            )}
                          </CSelect>
                        )}
                        <CButton
                          className="text-left m-0 p-0"
                          onClick={() => this.alunosRender(classes)}
                          style={{ boxShadow: "none" }}
                        >
                          <h4
                            className="m-0 p-0 d-flex align-items-center justify-content-end allocate-student-count"
                            style={{ width: "180px" }}
                          >
                            <span className="mr-2">
                              {classes.students_count} estudantes
                            </span>
                            {this.state.show === classes.room_id ? (
                              <RiArrowUpSLine />
                            ) : (
                              <RiArrowDownSLine />
                            )}
                          </h4>
                        </CButton>
                      </CCardHeader>
                      <CCollapse show={this.state.show === classes.room_id}>
                        <CCardBody className="pt-3 pb-0">
                          <div
                            id={`listUser_${classes.room_id}`}
                            className="d-flex flex-wrap"
                          >
                            {classes.users.map(user => (
                              <CCard
                                className={`user-card-allocate mb-3${
                                  user.checked ? " checked" : ""
                                }`}
                                onClick={() =>
                                  this.onChangeCheckBox({
                                    target: {
                                      id: `${classes.room_id}_${user.id}`
                                    }
                                  })
                                }
                              >
                                <div className="px-3 py-2 d-flex align-items-center h-100">
                                  <img
                                    src={
                                      URL.img +
                                      (user.photo ||
                                        "uploads/users/profileEmpty.jpg")
                                    }
                                    className="rounded-circle mr-2"
                                    style={{
                                      width: "24px",
                                      height: "24px"
                                    }}
                                  />
                                  {user.name}
                                </div>
                              </CCard>
                            ))}
                          </div>
                        </CCardBody>
                      </CCollapse>
                      {classes.allocation_id !== 0 && (
                        <CCardFooter className="flex-wrap">
                          <div className="d-flex flex-wrap align-items-center flex-1 allocate-datetime-row">
                            <div className="d-flex align-items-center allocate-datetime-group">
                              <span className="mr-2">Início:</span>
                              <Form.Control
                                type="datetime-local"
                                name={`start_${classes.room_id}`}
                                value={classes.start_allocation}
                                step="1"
                                onChange={e => this.onChangeAction(e)}
                                className="allocate-datetime-input"
                                style={{ width: "16rem" }}
                              />
                            </div>
                            <div className="d-flex align-items-center allocate-datetime-group">
                              <span className="ml-3 mr-2">Fim:</span>
                              <Form.Control
                                type="datetime-local"
                                name={`end_${classes.room_id}`}
                                value={classes.end_allocation}
                                step="1"
                                onChange={e => this.onChangeAction(e)}
                                className="allocate-datetime-input"
                                style={{ width: "16rem" }}
                              />
                            </div>
                            <div className="d-flex align-items-center allocate-datetime-group">
                              <span className="ml-3 mr-2">Para casa:</span>
                              <CSwitch
                                shape="pill"
                                color="primary"
                                checked={classes.homework}
                                onChange={e =>
                                  this.onChangeAction({
                                    target: {
                                      name: `homework_${classes.room_id}`,
                                      checked: e.target.checked
                                    }
                                  })
                                }
                              />
                            </div>
                          </div>
                          {!this.state.isAllocating ? (
                            <div className="d-flex flex-wrap allocate-footer-actions">
                              <CButton
                                color="primary"
                                className="d-flex justify-content-center align-items-center"
                                disabled={
                                  this.state.allocating === classes.room_id ||
                                  !(
                                    classes.start_allocation &&
                                    classes.end_allocation
                                  ) ||
                                  !this.isRoomEdited(classes)
                                }
                                onClick={() =>
                                  this.allocateAction(
                                    [classes.room_id],
                                    classes.start_allocation,
                                    classes.end_allocation,
                                    classes.homework
                                  )
                                }
                              >
                                <>
                                  <span
                                    style={
                                      this.state.allocating === classes.room_id
                                        ? { opacity: 0 }
                                        : null
                                    }
                                  >
                                    {classes.allocation_id !== 0
                                      ? "Salvar edição"
                                      : "Alocar"}
                                  </span>
                                  {this.state.allocating ===
                                    classes.room_id && (
                                    <CSpinner
                                      size="sm"
                                      color="white"
                                      style={{ position: "absolute" }}
                                    />
                                  )}
                                </>
                              </CButton>
                              <CButton
                                color="danger"
                                className="d-flex justify-content-center align-items-center ml-2"
                                disabled={
                                  this.state.deleting === classes.room_id
                                }
                                onClick={() =>
                                  this.setState({
                                    delete_id: classes.allocation_id,
                                    showDeleteModal: true
                                  })
                                }
                              >
                                <>
                                  <span
                                    style={
                                      this.state.deleting === classes.room_id
                                        ? { opacity: 0 }
                                        : null
                                    }
                                  >
                                    Apagar
                                  </span>
                                  {this.state.deleting === classes.room_id && (
                                    <CSpinner
                                      size="sm"
                                      color="white"
                                      style={{ position: "absolute" }}
                                    />
                                  )}
                                </>
                              </CButton>
                            </div>
                          ) : (
                            <div style={{ marginTop: "5px" }}>
                              <CSpinner size="sm" color="#114f72" />
                            </div>
                          )}
                        </CCardFooter>
                      )}
                    </CCard>
                  ))}
                </>
              ) : (
                <div className="p-5 text-center text-muted w-100">
                  {this.state.school_id ||
                  this.props.general.active_roles.school_id
                    ? "Nenhuma turma encontrada"
                    : "Selecione uma escola para realizar a alocação!"}
                </div>
              )}
            </Col>
          </Row>
        )}
        <DeleteModal
          show={this.state.showDeleteModal}
          onClose={() => this.setState({ showDeleteModal: false })}
          onDelete={() => this.deleteAction(this.state.delete_id)}
        />
        <ProtectedRoute routeId={this.props.currentRoute} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

class DeleteModal extends Component {
  constructor(props) {
    super(props);
    this.el = document.createElement("div");
  }

  componentDidMount() {
    appRoot.appendChild(this.el);
  }

  componentWillUnmount() {
    appRoot.removeChild(this.el);
  }

  render() {
    return ReactDOM.createPortal(
      <CModal
        color="danger"
        show={this.props.show}
        centered
        onClose={() => this.props.onClose()}
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>Apagar alocação</CModalHeader>
        <CModalBody>Deseja apagar a alocação?</CModalBody>
        <CModalFooter>
          <CButton color="danger" onClick={() => this.props.onDelete()}>
            Confirmar
          </CButton>
          <CButton color="secondary" onClick={() => this.props.onClose()}>
            Cancelar
          </CButton>
        </CModalFooter>
      </CModal>,
      this.el
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ActivityAllocate);
